/**
 * Set particle count for each container / scene on home
 * Icon particles are calculated from grid data length
 *
 * */

import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';
import dev from 'config/dev';

export default {
	introParticles: 500,
	transitionParticles: 0,
	iconParticles: 1571,
	iconParticlesMobile: 1000,
	extraIconOutterParticles: 500,
	screensParticles: 2800,
	screensHalftoneParticles: 2800,
	screensHalftoneParticlesMobileScale: 0.6,
	screensDropMachineParticles: 1100,
	screensDropMachineParticlesMobileScale: 0.5,
	spacesParticles: 2500,
	spacesParticlesMobile: 1500,

	//Systems is the LAST pool slice, so its count only extends total() (capacity)
	//and the systems index range — the S1 GATE scaling knob. Normally 3650 (the
	//shipped CPU count); the /dev/home ?sysCount=N benchmark override raises it so
	//the CPU SoA lanes / reference sprite pool grow with it (dev-gated, so
	//production is always 3650). A getter (not a one-shot write) because
	//indexesCache is populated once and never invalidated — reading the stable
	//URL value keeps total() and the first indexes() call consistent.
	get systemsParticles(): number {
		return dev.active && dev.systemsCount ? dev.systemsCount : 3650;
	},
	indexesCache: null,

	total() {
		return (
			this.introParticles +
			this.transitionParticles +
			this.iconParticles +
			this.screensParticles +
			this.spacesParticles +
			this.systemsParticles
		);
	},

	indexes() {
		if (!this.indexesCache) {
			this.indexesCache = {
				intro: this.introIndexes(),
				transitions: this.transitionsIndexes(),
				icon: this.iconIndexes(),
				screens: this.screensIndexes(),
				spaces: this.spacesIndexes(),
				systems: this.systemsIndexes()
			};
		}

		return this.indexesCache;
	},

	getParticlePool(particles: Array<HomeParticle>, type: string) {
		let indexes = this.indexes();
		return particles.slice(indexes[type].lower, indexes[type].upper);
	},

	transitionsIndexes() {
		return {
			lower: 0,
			upper: this.transitionParticles - 1
		};
	},

	introIndexes() {
		return {
			lower: this.transitionParticles,
			upper: this.transitionParticles + this.introParticles - 1
		};
	},

	iconIndexes() {
		return {
			lower: this.transitionParticles + this.introParticles,
			upper: this.transitionParticles + this.introParticles + this.iconParticles - 1
		};
	},

	screensIndexes() {
		return {
			lower: this.introParticles + this.transitionParticles + this.iconParticles,
			upper: this.introParticles + this.transitionParticles + this.iconParticles + this.screensParticles - 1
		};
	},

	spacesIndexes() {
		return {
			lower: this.introParticles + this.transitionParticles + this.iconParticles + this.screensParticles,
			upper:
				this.introParticles +
				this.transitionParticles +
				this.iconParticles +
				this.screensParticles +
				this.spacesParticles -
				1
		};
	},

	systemsIndexes() {
		return {
			lower:
				this.introParticles +
				this.transitionParticles +
				this.iconParticles +
				this.screensParticles +
				this.spacesParticles,
			upper:
				this.introParticles +
				this.transitionParticles +
				this.iconParticles +
				this.screensParticles +
				this.spacesParticles +
				this.systemsParticles -
				1
		};
	}
};
